module.exports = __webpack_public_path__ + "static/img/3-2-4.33cd18ad.jpg";